import React from "react";
import { motion } from "framer-motion";
import StickyNavbar from "../navbar";

const Chapter4Questions = () => {
    const questions = [
      "What are the steps involved in defining a research problem?",
      "How can existing literature help in formulating a research question?",
      "What are the main components of a research cycle?",
      "How can identifying stakeholders improve research outcomes?",
      "What is the significance of understanding the magnitude of a problem?",
      "How do researchers narrow down broad topics into specific questions?",
      "What role does team collaboration play in the research cycle?",
      "What are the challenges in identifying the causes of a health problem?",
      "How does evaluating existing solutions help in defining a research problem?",
      "What are common tools used to organize and plan research projects?"
    ];
  
    return (
      <div>
        <StickyNavbar />
        <div className="bg-gray-50 min-h-screen p-8 mt-10">
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-8"
          >
            <h1 className="text-3xl font-bold text-blue-900">
              Chapter 4 Questions
            </h1>
          </motion.div>
          <motion.ul
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
            className="space-y-4 text-lg"
          >
            {questions.map((question, index) => (
              <motion.li
                key={index}
                whileHover={{ scale: 1.05, x: 10 }}
                className="bg-white shadow-md p-4 rounded-lg border border-gray-200"
              >
                {index + 1}. {question}
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </div>
    );
  };

  export default Chapter4Questions